import { render, staticRenderFns } from "./review-result.vue?vue&type=template&id=a2b8efb2&scoped=true"
import script from "./review-result.vue?vue&type=script&lang=js"
export * from "./review-result.vue?vue&type=script&lang=js"
import style0 from "./review-result.vue?vue&type=style&index=0&id=a2b8efb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b8efb2",
  null
  
)

export default component.exports